/**
 * API helper — handles JWT token and base URL
 */
const API_BASE = process.env.REACT_APP_API_URL || '/api';

function getToken() {
  return localStorage.getItem('mi_token');
}

export function setToken(token) {
  localStorage.setItem('mi_token', token);
}

export function clearToken() {
  // HOTFIX (auth redirect loop): clear BOTH the token and the stored user.
  // Previously only mi_token was removed, leaving a stale mi_user in
  // localStorage. On a 401 reload, App.js would still see a user and render
  // the authenticated route tree, which then bounced /login back to /,
  // causing an infinite full-page-reload loop between / and /login.
  localStorage.removeItem('mi_token');
  localStorage.removeItem('mi_user');
}

export function getStoredUser() {
  const raw = localStorage.getItem('mi_user');
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (e) {
    // Corrupt mi_user in localStorage — treat as logged out rather than crash.
    localStorage.removeItem('mi_user');
    return null;
  }
}

export function setStoredUser(user) {
  localStorage.setItem('mi_user', JSON.stringify(user));
}

export async function api(path, options = {}) {
  const token = getToken();
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${API_BASE}${path}`, { ...options, headers });

  if (res.status === 401) {
    clearToken();
    // Defensive: only redirect if we're not already on the login page,
    // so a 401 on /login (e.g. from a bad password attempt) doesn't cause
    // a hard reload that drops the user's form state.
    if (window.location.pathname !== '/login') {
      window.location.href = '/login';
    }
    throw new Error('Session expired');
  }

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
}

export const get = (path) => api(path);
export const post = (path, body) => api(path, { method: 'POST', body: JSON.stringify(body) });
export const put = (path, body) => api(path, { method: 'PUT', body: JSON.stringify(body) });
export const patch = (path, body) => api(path, { method: 'PATCH', body: JSON.stringify(body) });
export const del = (path) => api(path, { method: 'DELETE' });
